import { useHitsPerPage } from "react-instantsearch";
import { cn } from "@repo/ui/lib/utils";
import Icon from "@repo/ui/components/ui/icon/icon";

export default function AlgoliaConfigure() {
  const { items, refine } = useHitsPerPage({
    items: [
      { label: "less", value: 30, default: true },
      { label: "more", value: 32 },
    ],
  });

  return (
    <div className="flex gap-4 justify-end items-center h-5 stroke-primary-black dark:stroke-primary-white">
      {items.map((item) => (
        <div key={item.label} role="button" onClick={() => refine(item.value)}>
          <Icon
            className={cn("w-[20px] h-[20px]", {
              "[&_svg]:stroke-primary-magenta dark:[&_svg]:stroke-primary-magenta":
                item.isRefined,
            })}
            icon={item.label === "less" ? "Square" : "Squares"}
          />
        </div>
      ))}
    </div>
  );
}
